"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _Button2 = _interopRequireDefault(require("../Button"));

var LinkButton =
/*#__PURE__*/
function (_Button) {
  (0, _inherits2.default)(LinkButton, _Button);

  function LinkButton() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, LinkButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(LinkButton)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleClick", function (e) {
      var _this$props = _this.props,
          history = _this$props.history,
          to = _this$props.to;
      e.stopPropagation();
      history.push(to);
    });
    return _this;
  }

  return LinkButton;
}(_Button2.default);

(0, _defineProperty2.default)(LinkButton, "propTypes", {
  Icon: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.instanceOf(_react.Component)]),
  label: _propTypes.default.node,
  to: _propTypes.default.string.isRequired,
  shortcut: _propTypes.default.string
});

var _default = (0, _reactRouterDom.withRouter)(LinkButton);

exports.default = _default;